import {Component, Inject, Vue} from 'vue-property-decorator';
import RegistrationService from '@/apis/registration';
import AccountService from "@/components/account/account.service";
// @ts-ignore
import md5 from 'crypto-js/md5';
import {required} from 'vuelidate/lib/validators';

const validations = {
  userName: {required},
  password: {required}
}

@Component({
  components: {},
  validations
})
export default class AuthorizationComponent extends Vue {

  @Inject('accountService') private accountService!: () => AccountService;
  @Inject('registrationService') private registrationService!: () => RegistrationService;


  public userName: string = '';
  public password: string = '';
  public wrongCredentials = false;
  public succeed = false;
  public errMsg = '';


  public async submit() {
    this.$store.commit('setOverlay', true)
    let authData = {
      "securityToken": this.$store.getters.token,
      "method": "7",
      "userName": this.userName,
      "password": (md5(this.password)).toString()
    }
    const auth = (await this.registrationService().authenticateContactForSelfSignIn(authData));
    if (auth.errMsg) {
      this.succeed = false;
      this.wrongCredentials = true;
      this.errMsg = auth.errMsg;
    } else {
      this.wrongCredentials = false
      this.succeed = true;
      this.errMsg = '';
      // @ts-ignore
      const clientId = auth.Relations.filter(relation=> relation.objectTypeID===7)[0].objectID;
      const contactId = auth.Contact.objectID;
		const login =  auth.Contact.name
		
		this.$store.commit('updateLogin', login);
      this.$store.commit('updateContactId', {contactId, clientId});
      // const signedIn = (await this.registrationService().getAContactsDetails()); //get client info
      this.clearFields();
      this.$emit('close-AuthDialog');
    }
    this.$store.commit('setOverlay', false)
  }

  public closeDialog() {
    this.clearFields();
    this.$emit('close-AuthDialog');
  }

  public toSignIn() {
    this.clearFields();
    this.$emit('toRegistration')
  }

  public clearFields(){
    this.userName = '';
    this.password = '';
    this.wrongCredentials = false;
    this.succeed = false;
    this.errMsg = '';
  }
}
